import { objectSpread2 as _objectSpread2 } from './_virtual/_rollupPluginBabelHelpers.mjs';
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { SizeWrapper, TouchWrapper } from './styles/styledComponents.mjs';
import { jsx, jsxs } from 'react/jsx-runtime';

var Svg24AddpositionB = /*#__PURE__*/React.memo(function (props) {
  useContext(ThemeContext);
  props.iconColor;
  var component = /*#__PURE__*/jsx("svg", _objectSpread2(_objectSpread2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24"
  }, props), {}, {
    children: /*#__PURE__*/jsxs("g", {
      fill: props.iconColor ? props.iconColor : "#010505",
      fillRule: "evenodd",
      children: [/*#__PURE__*/jsx("path", {
        d: "M11.8 6.25a2.949 2.949 0 0 1 .173 5.895l-.173.005-3.05-.001V15a.75.75 0 0 1-.648.743L8 15.75a.75.75 0 0 1-.743-.648L7.25 15V7a.75.75 0 0 1 .648-.743L8 6.25zm-3.05 4.399 3.05.001a1.451 1.451 0 0 0 .14-2.893l-.14-.007H8.75zM18 15a.75.75 0 0 1 .75.75v1.5h1.5a.75.75 0 0 1 0 1.5h-1.5v1.5a.75.75 0 0 1-1.5 0v-1.5h-1.5a.75.75 0 0 1 0-1.5h1.5v-1.5A.75.75 0 0 1 18 15"
      }), /*#__PURE__*/jsx("path", {
        d: "M18 2.25a2.75 2.75 0 0 1 2.745 2.582L20.75 5v7.666A6.002 6.002 0 0 1 18 24a6 6 0 0 1-5.334-3.25H5a2.75 2.75 0 0 1-2.745-2.582L2.25 18V5a2.75 2.75 0 0 1 2.582-2.745L5 2.25zm0 11.25a4.5 4.5 0 1 0 0 9 4.5 4.5 0 0 0 0-9m.128-9.744L18 3.75H5a1.25 1.25 0 0 0-1.244 1.122L3.75 5v13c0 .647.492 1.18 1.122 1.244L5 19.25h7.13a6 6 0 0 1 7.12-7.12V5a1.25 1.25 0 0 0-1.122-1.244"
      })]
    })
  }));
  if (props.size) {
    component = /*#__PURE__*/React.createElement(SizeWrapper, {
      size: props.size
    }, component);
  }
  if (props.touch) {
    component = /*#__PURE__*/React.createElement(TouchWrapper, {
      size: props.size,
      touch: props.touch
    }, component);
  }
  return component;
});
var Svg24AddpositionB$1 = Svg24AddpositionB;

export { Svg24AddpositionB$1 as default };
